;(function() {
  'use strict'

  surveysService.$inject = ["$q", "$rootScope", "locationService", "surveysResource", "surveyTemplatesResource", "glPrefs", "glSurveyUtils"];
  angular.module('core.services').service('surveysService', surveysService)

  // --------------------

  /* @ngInject */
  function surveysService(
    $q,
    $rootScope,
    locationService,
    surveysResource,
    surveyTemplatesResource,
    glPrefs,
    glSurveyUtils
  ) {
    var COMPLETED_PREF = 'completed-surveys'
    var prefs = glPrefs.create('surveysService')

    return {
      list: list,
      get: get,
      getTemplate: getTemplate,
      respond: respond,
      hasCompleted: hasCompleted,
    }

    // -----

    function list() {
      return $q(function(resolve, reject) {
        surveysResource
          .get()
          .success(function(res, data) {
            addExtras(data)
            resolve(data)
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }

    function get(id) {
      return $q(function(resolve, reject) {
        if (!id) {
          return reject()
        }
        surveysResource
          .get({ id: id })
          .success(function(res, data) {
            addExtras([data])
            resolve(data)
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }

    function getTemplate(id) {
      return $q(function(resolve, reject) {
        if (!id) {
          return reject()
        }
        surveyTemplatesResource
          .get({ id: id })
          .success(function(res, data) {
            addExtras([data])
            resolve(data)
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }

    /**
     * @name respond
     * @desc submit a survey response
     * @param {Object}  response
     * @param {String}  response.id the id of the survey to respond to
     * @param {Array}   response.answers the answers to the survey questions
     * @param {Array}   response.rd the reporting dimensions
     * @param {Array}   response.crd the custom reporting dimensions
     * @param {Object}  response.cd the custom data
     */
    function respond(response, options) {
      return $q(function(resolve, reject) {
        options = options || {}

        // HACK: Coles OneShop
        // adds region as a custom dimension for specific placesnearme questions
        var questionIds = [
          '49cdc89f-5fd7-4659-9ff1-d74c94f5269a', // How are you going? (production)
          '26809cb8-2dec-4770-a1e6-b02b149dd402', // Your Training Feedback Survey (production)
          '36976c46-103b-4595-b4c9-e54ec6205c21', // Test CRD Hack (staging)
        ]
        _.each(response.answers, function(question) {
          if (
            _.includes(questionIds, question.questionId) &&
            question.placesAnswers.length
          ) {
            // careful extraction
            var parenthesesRegex = /\(([^)]+)\)/
            var matches = parenthesesRegex.exec(question.placesAnswers[0].name)
            if (matches && matches[1]) {
              response.crd = response.crd || []
              response.crd.push({ Region: matches[1] })
            }
          }
        })

        var data = {
          surveyId: response.id,
          surveyResponse: {
            responseAnswers: response.answers,
          },
          reportDimensions: {
            rd: response.rd,
            crd: response.crd,
          },
          customData: response.cd,
          location: locationService.latest.position,
        }

        surveysResource
          .respond(data, null, options)
          .success(function() {
            $rootScope.$emit('survey:responded')
            storeCompleted(data.id)
            resolve()
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }

    function storeCompleted(surveyId) {
      // remember the past 20 surveys responded (per device)
      if (!surveyId) {
        return
      }
      var list = prefs.get(COMPLETED_PREF) || []
      if (list.length >= 20) {
        list.shift()
      }
      list.push(surveyId)
      prefs.set(COMPLETED_PREF, list)
    }

    function hasCompleted(surveyId) {
      if (!surveyId) {
        return
      }
      var list = prefs.get(COMPLETED_PREF)
      return _.includes(list, surveyId)
    }

    function addExtras(surveys) {
      _.each(surveys, function(survey) {
        console.log('parseSandboxData 2')
        glSurveyUtils.parseSandboxData(survey)

        survey.extras = {}
        // survey.extras.subtext = (survey.questions.length || '0') + ' questions';

        // order questions to get the correct numbering
        var questions = _.orderBy(survey.questions, 'order')

        _.each(questions, function(question, index) {
          var totalQuestions = survey.questions.length
          var currentQuestion = index + 1
          var percent = (currentQuestion / totalQuestions) * 100
          question.extras = {}
          question.extras.progress = percent
          question.extras.isLast = currentQuestion === totalQuestions
          question.extras.number = currentQuestion
          question.extras.total = survey.questions.length
          question.extras.showNumber = survey.data.showQuestionNumbers
        })
      })
    }
  }
})()
